import { debounce } from "lodash";
import React, { useContext, useEffect, useState } from "react";
import { RicosContext } from "./../../ricos-context";
import { Node_Type } from "./../../ricos-types";
import { getHost } from "./../../wix-rich-content-common";
import { Image } from "./../../ui-components";
import HtmlComponent from "../../plugin-html/lib/HtmlComponent";
import styles from "../statics/styles/link-preview-scss";
import { LINK_PREVIEW_TYPE } from "../types";
const LinkPreviewViewer = ({ componentData, settings, iframeSandboxDomain, helpers, nodeId }) => {
  const { enableEmbed = true } = settings;
  return enableEmbed && componentData.oembed?.html ? /* @__PURE__ */ React.createElement(
    SocialEmbedViewer,
    {
      componentData,
      settings,
      iframeSandboxDomain
    }
  ) : /* @__PURE__ */ React.createElement(LinkPreviewCard, { nodeId, componentData, helpers });
};
const SocialEmbedViewer = ({ componentData, settings, iframeSandboxDomain }) => {
  const { theme, isMobile } = useContext(RicosContext);
  const htmlCompProps = {
    componentData: {
      ...componentData,
      html: unescape(componentData.oembed.html)
    },
    settings,
    theme,
    isMobile,
    iframeSandboxDomain
  };
  return /* @__PURE__ */ React.createElement(HtmlComponent, { ...htmlCompProps });
};
const LinkPreviewCard = ({ componentData, helpers, nodeId }) => {
  const [imageHeight, setImageHeight] = useState(0);
  const [elementRef, setElementRef] = useState(null);
  const { isMobile } = useContext(RicosContext);
  const linkPreviewStyles = styles;
  useEffect(() => {
    if (!elementRef || !window?.ResizeObserver) {
      return;
    }
    const resizer = new ResizeObserver(
      debounce((entries) => {
        setImageHeight(Math.round(entries[0].contentRect.height));
      }, 60)
    );
    resizer.observe(elementRef);
    return () => {
      resizer.unobserve(elementRef);
    };
  }, [elementRef]);
  const getUrlForDisplay = (url) => url.replace(/^https?:\/\//, "");
  const onLinkPreviewClick = () => helpers?.onViewerAction?.(LINK_PREVIEW_TYPE, "Click", componentData.link.url || "", nodeId, {
    type: Node_Type.LINK_PREVIEW,
    linkPreviewData: componentData
  });
  const { title, description, thumbnailUrl } = componentData;
  const {
    linkPreview,
    linkPreviewUrl,
    linkPreviewInfo,
    linkPreviewTitle,
    linkPreviewImage,
    linkPreviewDescription
  } = linkPreviewStyles;
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
    /* @__PURE__ */ React.createElement(
      "figure",
      {
        className: linkPreview,
        "data-hook": "linkPreviewViewer",
        onClick: onLinkPreviewClick,
        ref: setElementRef
      },
      thumbnailUrl && /* @__PURE__ */ React.createElement(
        Image,
        {
          uri: thumbnailUrl,
          containerProps: {
            style: {
              height: imageHeight,
              width: isMobile ? 110 : imageHeight
            },
            className: linkPreviewImage
          },
          height: imageHeight,
          width: isMobile ? 110 : imageHeight,
          displayMode: "fill",
          alt: title
        }
      ),
      /* @__PURE__ */ React.createElement("section", { className: linkPreviewInfo }, /* @__PURE__ */ React.createElement("div", { className: linkPreviewUrl }, getUrlForDisplay(getHost(componentData.link.url) || componentData.link?.url || "")), /* @__PURE__ */ React.createElement("figcaption", { className: linkPreviewTitle }, title), description && /* @__PURE__ */ React.createElement("div", { className: linkPreviewDescription }, description))
    )
  );
};
export {
  LinkPreviewViewer
};
//# sourceMappingURL=link-preview-viewer.js.map
